import React, { useState } from "react";
import styles from "./FAQ.module.scss";
import visual from "../../../Components/assets/Images/visual.svg";
import avatar1 from "../../../Components/assets/Images/avatar1.svg";
import avatar2 from "../../../Components/assets/Images/avatar2.svg";
import minusicon from "../../../Components/assets/Images/minusicon.svg";
import plusicon from "../../../Components/assets/Images/plusicon.svg";
import { useNavigate } from "react-router-dom";

const QA = [
  {
    question:
      "What documents are required to open an NRI account with Firstock?",

    answer:
      "While there are no specific restrictions on NRI account transactions with Firstock, certain regulatory guidelines may apply depending on the nature of the transaction and the countries involved.",
  },
  {
    question:
      "Are there any restrictions on NRI account transactions with Firstock?",

    answer:
      "While there are no specific restrictions on NRI account transactions with Firstock, certain regulatory guidelines may apply depending on the nature of the transaction and the countries involved.",
  },
  {
    question: "How can I open an NRI account with Firstock?",

    answer:
      "While there are no specific restrictions on NRI account transactions with Firstock, certain regulatory guidelines may apply depending on the nature of the transaction and the countries involved.",
  },
  {
    question: "What are the benefits of opening an NRI account with Firstock?",
    type: "panel4",
    answer:
      "While there are no specific restrictions on NRI account transactions with Firstock, certain regulatory guidelines may apply depending on the nature of the transaction and the countries involved.",
  },
  {
    question:
      "Are there any restrictions on NRI account transactions with Firstock?",

    answer:
      "While there are no specific restrictions on NRI account transactions with Firstock, certain regulatory guidelines may apply depending on the nature of the transaction and the countries involved.",
  },
];

export default function FAQ() {
  const [opened, setopened] = useState(1);
  const navigate = useNavigate();

  return (
    <>
      <section className={styles.cardSection}>
        <div className={styles.mainWrapper}>
          <div className={styles.leftContainer}>
            <div className={styles.title}>
              Unlock Limitless Possibilities with Our Firstock Partners
            </div>
            <div className={styles.buttonsWrapper}>
              <div
                className={styles.getStarted}
                onClick={() => {
                  navigate("/email");
                }}
              >
                Get Started
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                >
                  <path
                    d="M9.33333 3.83594L14 8.5026M14 8.5026L9.33333 13.1693M14 8.5026L2 8.5026"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                className={styles.contactSales}
                onClick={() => {
                  window.open("https://firstock.in/contact", "_blank");
                }}
              >
                Contact Sales
              </div>
            </div>

            <div className={styles.countImage}>
              <div className={styles.count}>25K+</div>
              <div className={styles.avatarSection}>
                <div className={styles.avatars}>
                  <img src={avatar1} className={styles.avatar1} />
                  <img src={avatar2} className={styles.avatar1} />
                </div>
                <div className={styles.trustedText}>
                  Trusted by <br />
                  25K+ Professionals
                </div>
              </div>
            </div>
          </div>
          <div className={styles.RightContainer}>
            <img src={visual} alt="" className={styles.visualimage} />
          </div>
        </div>
      </section>

      <section className={styles.faqSection}>
        <div className={styles.faqWrapper}>
          <div className={styles.titleContainer}>
            <div className={styles.titleText} style={{ textAlign: "center" }}>
              You Ask, We Answer!
            </div>
          </div>

          <div className={styles.qandaWrapper}>
            {QA?.map((a: any, index: any) => (
              <div
                className={styles.qanda}
                onClick={() => {
                  setopened(index + 1);
                }}
                style={{ gap: opened === index + 1 ? "" : "0px" }}
              >
                <div className={styles.questionContainer}>
                  <div className={styles.left}>
                    <div className={styles.srl}>0{index + 1}</div>
                    {a.question}
                  </div>
                  <div className={styles.right}>
                    <img
                      src={opened === index + 1 ? minusicon : plusicon}
                      alt=""
                      className={styles.rightImage}
                    />
                  </div>
                </div>
                <div
                  className={styles.answer}
                  style={{ maxHeight: opened === index + 1 ? "200px" : "0px" }}
                >
                  {a.answer}
                </div>
              </div>
            ))}
          </div>

          <div className={styles.bottomText}>
            Have more questions?{" "}
            <span
              onClick={() => {
                window.open("https://firstock.in/contact", "_blank");
              }}
              style={{ color: "#3163E5", cursor: "pointer" }}
            >
              Contact our support
            </span>
          </div>
        </div>
      </section>
    </>
  );
}
